import { z } from 'zod';

export const registerSchema = z.object({
  name: z.string().min(1, 'Campo obrigatório'),
  email: z.email('Email inválido').min(1, 'Campo obrigatório'),
  company: z.string().min(1, 'Campo obrigatório'),
  employee_code: z.string().optional(),
});

export type RegisterFormData = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  email: z.string().min(1, 'Campo obrigatório'),
  password: z.string().min(1, 'Campo obrigatório'),
});

export type LoginFormData = z.infer<typeof loginSchema>;
